import { Box } from "theme-ui";

export default function CheckmarkCircleIcon(props) {
  return (
    <Box
      as="svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.0746 9.90861C14.3498 9.15763 14.5 8.34635 14.5 7.5C14.5 3.63401 11.366 0.5 7.5 0.5C3.63401 0.5 0.5 3.63401 0.5 7.5C0.5 11.366 3.63401 14.5 7.5 14.5C8.34635 14.5 9.15762 14.3498 9.90861 14.0746"
        stroke="white"
      />
      <path
        d="M10.7763 16.3307L7.51824 7.85962C7.43607 7.64598 7.64598 7.43607 7.85962 7.51824L16.3307 10.7763C16.562 10.8653 16.5545 11.1951 16.3194 11.2735L12.535 12.535L11.2735 16.3194C11.1951 16.5545 10.8653 16.562 10.7763 16.3307Z"
        stroke="white"
        strokeLinecap="round"
      />
      <path
        d="M10.3391 8.47188C10.4434 8.16708 10.5 7.84015 10.5 7.5C10.5 5.84315 9.15685 4.5 7.5 4.5C5.84315 4.5 4.5 5.84315 4.5 7.5C4.5 9.15685 5.84315 10.5 7.5 10.5C7.84015 10.5 8.16708 10.4434 8.47188 10.3391"
        stroke="white"
      />
    </Box>
  );
}
